import PropTypes from 'prop-types'
import React from 'react'

export default function Bool({ value, truthy, falsy }) {
  const token = value ? '✓' : '✗'
  const str = value ? truthy : falsy
  const html = `${token}${str ? (` ${str}`) : ''}`
  // eslint-disable-next-line
  return <span dangerouslySetInnerHTML={{ __html: html }} />
}

Bool.propTypes = {
  falsy: PropTypes.string,
  truthy: PropTypes.string,
  value: PropTypes.any,
}



// WEBPACK FOOTER //
// ./src/frontend/shared/components/Bool.js